import { Reveal } from "../Reveal";
import { ROADMAP } from "../../content";

export const Roadmap = () => (
  <section className="border-y border-white/10" data-testid="roadmap-section">
    <div className="grid md:grid-cols-4">
      {ROADMAP.map((s, i) => (
        <Reveal
          key={i}
          delay={i * 0.08}
          className={`relative overflow-hidden px-8 py-16 ${i < 3 ? "md:border-r border-b md:border-b-0 border-white/10" : ""}`}
          data-testid={`roadmap-step-${i}`}
        >
          <span className="mono absolute -top-4 -right-2 text-[120px] font-bold text-white/[0.04] select-none" aria-hidden="true">
            {s.num}
          </span>
          <div className="relative">
            <div className="mono text-[13px] tracking-[0.3em] text-[#FFC631] mb-4">{s.label}</div>
            <h3 className="serif font-black uppercase text-2xl text-white mb-3">{s.name}</h3>
            <p className="text-sm text-white leading-relaxed">{s.desc}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
